export default function ({ store, redirect }) {
  if (store.getters['user/isPortalUser']) {
    return redirect(window.$nuxt.$config.portalURL);
  }
  if (!store.getters['system/isIPAllowed']) {
    return redirect('/ip-not-allowed');
  }
}
